import React from 'react';

const OwnerTextIntro = () => {
  return (
    <p className="text-gray">
      Below are the terms that you originally proposed and a draft of your
      agreement. You can also see the feedback that your team has provided.
      Using your team’s feedback, you can choose to keep or change your original
      proposal before finalizing your agreement. Start with the first tab of
      questions and click "continue" to move to the next. Once your entire team
      has approved the agreement, scroll down to the bottom of the "Terms
      Summary" and click on "Finalize Now" to allow everyone to sign.
    </p>
  );
};

export default OwnerTextIntro;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/OwnerTextIntro.js